import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class CompanyTheme {
    getCompanyTheme(id) {
        return BaseService.get(`${APIPath.companyTheme}/${id}`)
    }

    add(data) {
        return BaseService.post(`${APIPath.insertColorTheme}`, data)
    }

    update(data) {
        return BaseService.post(`${APIPath.updateColorTheme}`, data)
    }
}

const CompanyThemeService = new CompanyTheme()
Object.freeze(CompanyThemeService)
export { CompanyThemeService }
